var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 53.3218,
  y: 69.8359,
  width: 58.4984,
  height: 49.5496,
  rx: 8,
  transform: "rotate(-154.644 53.3218 69.8359)",
  fill: "#E5EFEB"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 8.45898,
  y: 11.0078,
  width: 58,
  height: 50,
  rx: 9,
  fill: "#E5EFEB",
  stroke: "white",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.959 25.0156C17.4067 25.0156 16.959 25.4633 16.959 26.0156V45.349C16.959 45.9012 17.4067 46.349 17.959 46.349H44.4034C44.9557 46.349 45.4034 45.9012 45.4034 45.349V37.0674L55.3442 44.8155C56.0009 45.3274 56.959 44.8594 56.959 44.0268V27.3368C56.959 26.5042 56.0009 26.0362 55.3442 26.5481L45.4034 34.2962V26.0156C45.4034 25.4633 44.9557 25.0156 44.4034 25.0156H17.959Z",
  fill: "url(#paint0_linear_490_1386)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_490_1386",
  x1: 27.8479,
  y1: 35.6819,
  x2: 49.8479,
  y2: 35.4596,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#486877"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#569CA4"
})));

function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 70,
    viewBox: "0 0 75 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.e9638d0d.svg";
export { ForwardRef as ReactComponent };